<script setup>
import { defineProps, toRefs, defineEmits, defineExpose, inject, ref } from 'vue';
import { useRoute } from "vue-router";
// import i18n from "@/i18n"
import Swal from "sweetalert2";
import { getHscodeDetail } from "@/service/index"
import {getLangValueByKey } from "@/utils/common"; //获取后端语言
const props = defineProps({
    formData: {
        type: Object,
        required: true,
        default: () => { }
    }
})
const emits = defineEmits(["update:formData"])
const { formData } = toRefs(props)
const route = useRoute()
const hscodeList = inject('hscodeList')
const currentTabLang = inject('currentTabLang')
const current_hscode = inject('current_hscode')
const templateList = inject('templateList')
// // 新增的模板字段  

const addTemplateInfoFields = () => {
    let m = {
        name: `${getLangValueByKey('product-template.template_text_field')}${formData.value.addfieldsList.length + 1}`,
        name_en: `${getLangValueByKey('product-template.template_text_field','en')}${formData.value.addfieldsList.length + 1}`,
        label: `${getLangValueByKey('product-template.template_text_field')}${formData.value.addfieldsList.length + 1}`,
        label_en: `${getLangValueByKey('product-template.template_text_field', 'en')}${formData.value.addfieldsList.length + 1}`,
        key: `filed-${formData.value.addfieldsList.length + 1}`,
        value: "",
        type: 1, // 自己新增的
        extra: {
            type: 99,
        },
        required: false,
        deletable: true,
    }
    formData.value.addfieldsList.push(m)
    emits("update:formData", formData.value)
}
// 编辑字段名称
const editFields = (index) => {
    const { label, label_en } = formData.value.addfieldsList[index]
    Swal.fire({
        title:currentTabLang.value ==1?  getLangValueByKey("product-template.enterFieldName"): getLangValueByKey("product-template.enterFieldName", 'en'),
        input: "text",
        inputValue: currentTabLang.value == 1? label: label_en,
        showCancelButton: true,
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
        showLoaderOnConfirm: true,
        confirmButtonColor: "#0AB39c",
        cancelButtonColor: "#f06548",
        inputValidator: (value) => {
            if (!value) {
                return currentTabLang.value == 1? getLangValueByKey("product-template.requeiredInfo"): getLangValueByKey("product-template.requeiredInfo", 'en')
            }
        },
        preConfirm: (value) => {
            if (value) {
                if (currentTabLang.value == 1) {
                    formData.value.addfieldsList[index].label = value
                    formData.value.addfieldsList[index].name = value
                } else {
                    formData.value.addfieldsList[index].label_en = value
                    formData.value.addfieldsList[index].name_en = value
                }

                emits('update:formData', formData.value)
            }

        },
        allowOutsideClick: false,
    }).then((text) => {
        console.log(text);
    });
}
// 删除字段
const deleteFields = (index) => {
    Swal.fire({
        title: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_title"): getLangValueByKey("base.delete_alert_title", 'en'),
        text: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_info"): getLangValueByKey("base.delete_alert_info", 'en'),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
    }).then(async (result) => {
        if (result.isConfirmed) {
            formData.value.addfieldsList.splice(index, 1)
            emits("update:formData", formData.value)
        }
    });

}

const isCheckForm = inject('isCheckForm') // 是否验证表单
// 验证表单
const checkForm = () => {
    isCheckForm.value = true
    let checkResult = true
    for (let k in formData.value.fieldsList) {
        if (formData.value.fieldsList[k].required && !formData.value.fieldsList[k].value) {
            checkResult = false
            currentTabLang.value =1;
            break;
        }
        //验证template_info_template_name英文是否为空
        if (formData.value.fieldsList[k].required &&  !formData.value.fieldsList[k].value_en && formData.value.fieldsList[k].key == 'template_info_template_name') {
            checkResult = false
            currentTabLang.value =2;
            break;
        }
       
    }
    return checkResult;
}

const changeTemplate = () => {
    // 切换数据库模板 复现 hscode
    if (formData.value.fieldsList[0].value) {
        // 給 hscode 显示值
        // console.log(formData.value.fieldsList[0].value);
        let arr = templateList.value.filter(item => item.name === formData.value.fieldsList[0].value)
        if (arr.length) {
            formData.value.fieldsList[0].value_en = arr[0].name_en
            console.log(formData.value.fieldsList[0].value_en);
            emits("update:formData", formData.value)
        }
    }
}
const changeTemplate1 = () => {
    // 切换数据库模板 复现 hscode
    if (formData.value.fieldsList[0].value_en) {
        // 給 hscode 显示值
        // console.log(formData.value.fieldsList[0].value);
        let arr =  templateList.value.filter(item => item.name_en === formData.value.fieldsList[0].value_en)
        if (arr.length) {
            formData.value.fieldsList[0].value = arr[0].name
            emits("update:formData", formData.value)
        }
    }
}

const refs = ref([]);
const addRefs = (i) => {
    return (el) => {
        refs.value[i] = el;
        // refs.value[0].togglePopperVisible(true)
    };
}
const getDetailValue = (key) => {
    // 根据key 获取value
    let obj = formData.value.fieldsList.find(item => item.key == key)
    return obj ? obj.value : ''
}

const setDetailValue = (key, value, valueKey = 'value') => {
    // 根据key 设置value
    let obj = formData.value.fieldsList.find(item => item.key == key)
    obj[valueKey] = value;
}

const changeHscode = async (node) => {
    // console.log(formData.value.fieldsList[1].value);
    let hscode_value = getDetailValue('template_info_hscode')
    // let des_value = getDetailValue('描述')
    if (hscode_value) {
        current_hscode.value = hscode_value
    } else {
        current_hscode.value = []
        setDetailValue('template_info_description', '')
        setDetailValue('template_info_description', '', 'value_en')
    }
    // 修改描述
    // formData.value.fieldsList[2].value = ''
    // formData.value.fieldsList[3].list = []
    setDetailValue('template_info_description', '')
    setDetailValue('template_info_description', '', 'value_en')
    if (node) {
        console.log(node);
        let nodeData = [...node]
        // console.log(nodeData[0].data.destination_market_list);
        // let description = nodeData[0].data.description
        // formData.value.fieldsList[2].value = description? description: '-'
        let params = {
            ignore_fields: '["index_standards"]'
        }
        const reps = await getHscodeDetail(nodeData.pop(), params)
        // console.log(reps);
        if (reps.code == 0) {
            setDetailValue('template_info_description', reps.payload.description ? reps.payload.description : '-')
            setDetailValue('template_info_description', reps.payload.description_en ? reps.payload.description_en : '-', 'value_en')
        }
        // 设置目的市场
        // if (nodeData[0].data.destination_market_list.length) {
        //     formData.value.fieldsList[3].list = nodeData[0].data.destination_market_list.filter(item => item.destination_market).map(item => {
        //         return { name: item.destination_market, value: item.id }
        //     })
        // }
        // console.log(nodeData[0].data.description);
        // let arr = formData.value.fieldsList[1].list.filter(element => element.id == node[0]);
        // if (arr.length) {
        //     let arr1 = arr[0].children.filter(element => element.id == node[1])
        //     console.log(arr1);
        //     if (arr1.length) {
        //         // console.log(arr1[0].description);
        //         formData.value.fieldsList[2].value = arr1[0].description ? arr1[0].description : '-'
        //     }
        // }
    }
}

const getChildrenById = (tree, id) => {
    for (let node of tree) {
        if (node.id === id) {
            return node.children;
        }
        if (node.children.length) {
            const result = getChildrenById(node.children, id);
            if (result) return result;
        }
    }
    return null; // 如果未找到匹配的 id，返回 null
}

const changeHscode1 = (node) => {
    // 切换目标市场
    // console.log(node);
    if (node) {
        let children = getChildrenById(hscodeList.value, node[1])
        console.log(children);
        // formData.value.fieldsList[2].list = [...children]
        setDetailValue('template_info_hscode', [...children], 'list')

    } else {
        // formData.value.fieldsList[2].list = []
        // formData.value.fieldsList[2].value = ''
        setDetailValue('template_info_hscode', [], 'list')
        setDetailValue('template_info_hscode', '')
    }
}


defineExpose({
    checkForm,
})
</script>
<template>
    <b-card class="product-basic-form">
        <div class="row gy-3 w-100 ">
            <div
                style="font-weight: 500;border-bottom: 1px solid #E9EBEC; margin: 10px 0;font-size: 16px; height: 40px; line-height: 40px;">
                {{ currentTabLang == 1 ?formData.title:  formData.title_en}}
            </div>
            <div class="row  d-flex justify-content-start">
                <div class="col-4 mt-2" v-for="(item, index) in formData.fieldsList" :key="index">
                    <label class="form-label">
                        <span class="text-danger">*</span>
                        <span>{{ currentTabLang == 1 ? item.label : item.label_en }}</span>
                    </label>
                    <div style="height: 40px;">
                        <template v-if="item.type1 === 'list'">

                            <el-select v-show="currentTabLang == 1" id="dataBase" v-model="item.value" placeholder=" "
                                size="large" style="width: 100%; " clearable filterable allow-create
                                default-first-option
                                :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']"
                                :disabled="route.query.type == 'view' || item.disabled" @change="changeTemplate">
                                <el-option v-for="item1 in item.list" :key="item1.id" :label="item1.name"
                                    :value="item1.name" />
                            </el-select>
                            <el-select v-show="currentTabLang == 2" id="dataBase1" v-model="item.value_en"
                                placeholder=" " size="large" style="width: 100%; " clearable filterable allow-create
                                default-first-option
                                :class="[(isCheckForm && !item.value_en && item.required) && 'is-invalid']"
                                :disabled="route.query.type == 'view' || item.disabled" @change="changeTemplate1">
                                <el-option v-for="item1 in item.list" :key="item1.id" :label="item1.name_en"
                                    :value="item1.name_en" />
                            </el-select>
                        </template>
                        <template v-else-if="item.type1 === 'cascader'">
                            <template v-if="item.key == 'template_info_destination_market'">
                                <el-cascader placeholder="HS Code" style="width: 100%; height: 40px;"
                                    @change="changeHscode1"
                                    :props="{ label: currentTabLang == 1 ? 'title' : 'title_en', value: 'id' }"
                                    :show-all-levels="false" v-model="item.value" :options="item.list" filterable
                                    :class="[(isCheckForm && !item.value && item.required) && 'is-invalid122']"
                                    :disabled="route.query.type == 'view' || item.disabled" clearable />
                            </template>
                            <template v-if="item.key == 'template_info_hscode'">
                                <el-cascader :ref="addRefs(index)" placeholder="HS Code"
                                    style="width: 100%; height: 40px;" @change="changeHscode"
                                    :props="{ label: currentTabLang == 1 ? 'title' : 'title_en', value: 'id' }"
                                    :show-all-levels="false" v-model="item.value" :options="item.list" filterable
                                    :class="[(isCheckForm && !item.value && item.required) && 'is-invalid122']"
                                    :disabled="route.query.type == 'view' || item.disabled" clearable />
                            </template>
                        </template>
                        <template v-else-if="item.key == 'template_info_description'">
                            <input v-show="currentTabLang ==1" clearable class="form-control" v-model="item.value"
                                :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']" required
                                :disabled="route.query.type == 'view' || item.disabled" />
                            <input v-show="currentTabLang ==2" clearable class="form-control" v-model="item.value_en"
                                :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']" required
                                :disabled="route.query.type == 'view' || item.disabled" />
                        </template>
                        <input v-else clearable class="form-control" v-model="item.value"
                            :class="[(isCheckForm && !item.value && item.required) && 'is-invalid']" required
                            :disabled="route.query.type == 'view' || item.disabled" />
                    </div>
                </div>
                <!-- 新增字段部分 -->
                <div class="col-4 mt-2" v-for="(item, index) in formData.addfieldsList" :key="index">
                    <label class="form-label">
                        <span class="text-danger"></span>
                        <span>{{ currentTabLang == 1 ? item.label : item.label_en }}</span>
                        <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                            @click="editFields(index)"></i>
                    </label>
                    <div class="d-flex align-items-center">
                        <input clearable type="number" maxlength="6" class="form-control"
                            style="display: inline; flex:1" disabled />
                        <i class="fs-16 ri-delete-bin-5-fill cursor-pointer" v-if="route.query.type != 'view'"
                            style="color: #F06548; margin-left: 4px;" @click="deleteFields(index)"></i>
                    </div>
                </div>
            </div>
            <div style="text-align: center;">
                <button :disabled="route.query.type == 'view'" type="button" class="btn btn-success me-3"
                    @click="addTemplateInfoFields()" style="min-width: 120px;">
                    <i class="ri-add-fill me-1 align-bottom"></i>
                    {{ currentTabLang == 1? getLangValueByKey("product-template.addField"): getLangValueByKey("product-template.addField", 'en') }}
                </button>
            </div>
        </div>
    </b-card>
</template>
<style scoped lang="scss">
.product-basic-form {
    .is-invalid {
        border: 1px solid #f06548 !important;
        border-radius: 4px;

        .el-input__wrapper {
            border: 1px solid #f06548 !important;
            border-radius: 4px;
        }
    }

    .is-invalid1 {
        border: 1px solid #f06548 !important;
        border-radius: 4px;
    }

    :deep(.el-select__wrapper) {
        min-height: 35.5px !important;
    }

    :deep(.el-input--suffix) {
        height: 100%;
    }
}
</style>
<style>
.is-invalid122 {
    border: 1px solid #f06548 !important;
    border-radius: 4px;
}
</style>